/**
* @description 是否在3d内嵌页中
*/
export const checkIsIn3D = () => {
  try {
    return window.self !== window.top
    // return true
  } catch (e) {
    return true;
  }
}

export const isIn3D = checkIsIn3D()

/**
 * @description 获取url参数
 * @param key 
 * @returns 
 */
export function getValueFromSearchParams(key: string): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
}

// 3d 模式下，iframe 扩展宽度（用于卡片详情等内容iframe外显示效果）
export const expandIframeWidth = isIn3D ? Number(getValueFromSearchParams('expandIframeWidth')) || 350 : 0
